import React from 'react';
import BadgeTotem from '../components/BadgeTotem';

/**
 * Badge utility functions shared between the main badge and secondary surfaces.
 * The animal progression is Kata.fit-owned SVG geometry from BadgeTotem.js.
 */

export const getCentralShape = yearRate => <BadgeTotem rate={yearRate} />;

// Simple defaults for standalone use (matches App.js shimmer classes)
export const getShimmerClass = monthRate => {
  if (monthRate >= 100) return 'shimmer shimmer-obsidian';
  if (monthRate >= 90) return 'shimmer shimmer-gold';
  if (monthRate >= 60) return 'shimmer shimmer-silver';
  if (monthRate >= 30) return 'shimmer shimmer-bronze';
  return '';
};

// Flame class based on weekly compliance rate (matches App.css flame-outline classes)
export const getFlameClass = weekRate => {
  if (weekRate >= 100) return 'flame-outline-platinum';
  if (weekRate >= 90) return 'flame-outline-white';
  if (weekRate >= 60) return 'flame-outline-orange';
  if (weekRate >= 30) return 'flame-outline-red';
  return '';
};

export const BADGE_STAR_POINTS = '0,-1 0.224,-0.309 0.951,-0.309 0.363,0.118 0.588,0.809 0,0.382 -0.588,0.809 -0.363,0.118 -0.951,-0.309 -0.224,-0.309';

export const getStars = () => ({ items: [], bounds: null });
